import { createRoute } from '@tanstack/react-router';
import { authenticatedRoute } from '@/router/authenticated-route';
import CompaniesPage from '@/features/companies/companies-list/CompaniesPage';
import {
  CompaniesSearchSchema,
  type CompaniesSearch,
} from '@/features/companies/companies-list/companies-search.schema';
import {
  companiesInfiniteQueryOptions,
  companiesQueryOptions,
} from '@/features/companies/companies-list/companies-query';

/**
 * `/` is the recruiter Home — per the latest Figma the home IS the
 * companies listing (consultor-scoped). The previous `/companies` route
 * was folded back into the home; the navbar no longer carries a separate
 * "Empresas" entry.
 */
export const homeRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/',
  // Bookmarkable URL state — falls back to defaults on malformed values.
  validateSearch: (raw) => CompaniesSearchSchema.parse(raw),
  // Non-blocking prefetch — kicks off the companies fetch as the route loads
  // but does NOT await it. The container's `useQuery`/`useInfiniteQuery`
  // (with `placeholderData: keepPreviousData`) then either hits the warm
  // cache or shows its own cold-load fallback.
  loaderDeps: ({ search }) => search as CompaniesSearch,
  loader: ({ context, deps }) => {
    if (deps.view === 'table') {
      void context.query.prefetchQuery(companiesQueryOptions(deps));
    } else {
      void context.query.prefetchInfiniteQuery(companiesInfiniteQueryOptions(deps));
    }
  },
  component: CompaniesPage,
});
